// ============================================================
// 市场端接口（cs8 独立应用 app/market，URL 形如 /market/<action>）
// 对接图谱 §九 / §十五；共 13 条动作
// 说明：market 与 finance 为「同主机不同应用」，复用 util/request 的
//       baseURL + token/enterprise 头，无需额外鉴权头。
// ============================================================
import request from '../util/request'

const APP = '/market/'

function post(url, data) {
  return request({
    url: APP + url,
    method: 'post',
    data: data || {}
  })
}
function get(url, params) {
  return request({
    url: APP + url,
    method: 'get',
    params: params || {}
  })
}

// ---- 账号画像（角色 / 部门 / 数据范围）----
export function marketMyProfile(data) {
  return get('myProfile', data)
}

// ---- 客户：全量只读 + 自建可写 ----
export function marketCustomersList(data) {
  return post('customersList', data)
}
// 客户表单字典（type / publish_status / use / industry / source / store）
// ⚠️ publish_status 口径与 customersList 的筛选一致（1 待分配 2 已接收 3 跟进中 4 已完成）
export function marketCustomersOption(data) {
  return post('customersOption', data)
}
export function marketCustomerDetail(data) {
  return get('customerDetail', data)
}
export function marketCustomerSave(data) {
  return post('customerSave', data)
}
export function marketCustomerDelete(data) {
  return post('customerDelete', data)
}

// ---- 批量分配 ----
export function marketAssignablePool(data) {
  return get('assignablePool', data)
}
export function marketCustomerBatchAssign(data) {
  return post('customerBatchAssign', data)
}

// ---- 五类单据全量只读 ----
export function marketOpportunitiesList(data) {
  return post('opportunitiesList', data)
}
export function marketOrdersList(data) {
  return post('ordersList', data)
}
export function marketRoomOrdersList(data) {
  return post('roomOrdersList', data)
}
export function marketValueAddedOrdersList(data) {
  return post('valueAddedOrdersList', data)
}
export function marketFinanceContractsList(data) {
  return post('financeContractsList', data)
}

// ---- 统计（全量）----
export function marketStatisticsDashboard(data) {
  return get('statisticsDashboard', data)
}


// ============================================================
// P47：与销售 CRM（src/api/api.js）同名的函数 —— 市场端镜像
//   URL 统一为 /market/<action>，由 app/market 委托 app\client 实现，
//   从而保证市场端 H5 的列表与详情（含合同）与销售端结构完全一致。
//   数据范围：委托时置 $_marketAll=true ⇒ 列表全量（市场部门=全量只读）。
// ============================================================

export function customerAllocationAction(data) {
  return post('customerAllocationAction', data)
}

export function customerAllocationBatch(data) {
  return post('customerAllocationBatch', data)
}

export function deleteContactData(data) {
  return post('contactDelete', data)
}

export function deleteOpportunitiesData(data) {
  return post('opportunitiesDelete', data)
}

export function deleteRoomOrderData(data) {
  return post('roomOrder/delete', data)
}

export function deleteVisitData(data) {
  return post('visitDelete', data)
}

export function getClientOrderDetailData(data) {
  return post('getOrderDetail', data)
}

export function getContractAddedServiceListData(data) {
  return post('orderAddedServiceList', data)
}

export function getContractApprovalListData(data) {
  return post('orderApprovalList', data)
}

export function getContractBalanceListData(data) {
  return post('orderBalanceList', data)
}

export function getContractCollectionListData(data) {
  return post('orderCollectionList', data)
}

export function getContractFinanceContractListData(data) {
  return post('orderFinanceContractList', data)
}

export function getContractFlowData(data) {
  return post('contractFlow', data)
}

export function getContractFlowDetailData(data) {
  return post('contractFlowDetail', data)
}

export function getContractInvoiceListData(data) {
  return post('orderInvoiceList', data)
}

export function getContractPaymentListData(data) {
  return post('orderPaymentList', data)
}

export function getContractRefundListData(data) {
  return post('orderRefundList', data)
}

export function getContractRoomOrderListData(data) {
  return post('orderRoomOrderList', data)
}

export function getContractsStatData(data) {
  return post('contractsStat', data)
}

export function getCustomersDetailData(data) {
  return post('customersDetail', data)
}

export function getCustomersListData(data) {
  return post('customersList', data)
}

export function getCustomersOptionData(data) {
  return post('customersOption', data)
}

export function getLogListData(data) {
  return post('logList', data)
}

export function getManagedStaffData(data) {
  return post('getManagedStaff', data)
}

export function getMessageListData(data) {
  return post('messageList', data)
}

export function getOpportunitiesDetailData(data) {
  return post('opportunitiesDetail', data)
}

export function getOpportunitiesListData(data) {
  return post('opportunitiesList', data)
}

export function getOpportunitiesStageListData(data) {
  return post('opportunitiesStageList', data)
}

export function getOpportunitiesStatData(data) {
  return post('opportunitiesStat', data)
}

export function getOrdersDetailData(data) {
  return post('ordersDetail', data)
}

export function getOrdersListData(data) {
  return post('ordersList', data)
}

export function getOrdersStatData(data) {
  return post('ordersStat', data)
}

export function getPaymentOwnerOptions(data) {
  return post('orderPaymentOwnerOptions', data)
}

export function getQiniuToken(data) {
  return get('getQiniuToken', data)
}

export function getRoomDate(data) {
  return post('getRoomDate', data)
}

export function getRoomOrderDetailData(data) {
  return post('roomOrder/getDetailData', data)
}

export function getRoomOrderFormData(data) {
  return post('roomOrder/getFormData', data)
}

export function getRoomOrderListData(data) {
  return post('roomOrder/getListData', data)
}

export function getRooms(data) {
  return post('getRooms', data)
}

export function getStatisticsDashboardData(data) {
  return post('statisticsDashboard', data)
}

export function getStores(data) {
  return post('getStores', data)
}

export function saveContactData(data) {
  return post('contactSave', data)
}

export function saveCustomersData(data) {
  return post('customersSave', data)
}

export function saveOpportunitiesData(data) {
  return post('opportunitiesSave', data)
}

export function saveOrdersData(data) {
  return post('ordersSave', data)
}

export function saveRoomOrderData(data) {
  return post('roomOrder/save', data)
}

export function saveVisitData(data) {
  return post('visitSave', data)
}

/* 【P130】消息已读上报（委托 client） */
export function messageReadData(data) {
  return post('messageRead', data)
}
export function messageReadAllData() {
  return post('messageReadAll', {})
}
/* 【P247】「未读」Tab 批量标记已读 */
export function messageReadBatchData(data) {
  return post('messageReadBatch', data)
}
/* 【P247】「全部」Tab 批量删除（软删，后端已做归属校验） */
export function messageDeleteData(data) {
  return post('messageDelete', data)
}



// WEBPACK FOOTER //
// ./src/api/market.js